import { jsx as _jsx } from "react/jsx-runtime";
import * as Colors from './colors';
import { split } from './common';
export function renderXml(source) {
    var parts = split(source);
    var result = [];
    var color = 'white';
    var isProperty = false;
    var inElement = false;
    var key = 0;
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var token = parts_1[_i];
        var tokenHandled = false;
        if (!isProperty && token === '"') {
            isProperty = true;
            color = Colors.attributeValueColor;
            tokenHandled = true;
        }
        if (token === '<' || token === '>' || token === '?' || token === '/') {
            color = Colors.signColor;
        }
        if (token === ' ') {
            if (inElement) {
                color = Colors.attributeNameColor;
            }
            else {
                color = Colors.defaultColor;
            }
        }
        result.push(_jsx("span", { style: { color: color }, children: token }, key));
        key++;
        if (tokenHandled) {
            continue;
        }
        if (token === '<') {
            color = Colors.elementColor;
            inElement = true;
        }
        if (isProperty && token === '"') {
            isProperty = false;
            color = Colors.defaultColor;
        }
        if (token === '>') {
            color = Colors.defaultColor;
            inElement = false;
        }
        if (token === '?' || token === '/') {
            color = Colors.elementColor;
        }
    }
    return result;
}
